// extracted by mini-css-extract-plugin
export default {"TermsConditionsContainer":"TermsConditions_TermsConditionsContainer__HpDUY","closeCart":"TermsConditions_closeCart__x7PFW","TermsConditions":"TermsConditions_TermsConditions__etPMd"};